import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import createComplectationOptions from '../../../api/cars/createComplectationOptions';

// components
import Form from '../../../components/Form/Form';
import Header from '../../../components/Header/Header';

// icons
import icon from '../../../brand/generated/sidebar/cars.svg';

const formStyles = {
  option: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
};

const CarOptionsCreate = () => {
  const navigate = useNavigate();
  const [option, setOption] = useState([
    { type: 'input', value: undefined, label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ' },
    { type: 'selectComplectations', value: 6 },
  ]);

  const createOptionCar = () => {
    createComplectationOptions({
      title: option[0].value,
      complectationId: option[1].value,
      type_id: 1,
    }).then(() => navigate('/cars/options'));
  };

  return (
    <>
      <Header title={'ÐÐ¾Ð²Ð°Ñ Ð¾Ð¿ÑÐ¸Ñ'} icon={icon} />
      <div style={{ paddingBottom: '20px' }}>
        <Form
          inputs={option}
          title={'ÐÐ¿ÑÐ¸Ð¸'}
          grid={formStyles.option}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
          handlerSetState={setOption}
          handleSubmit={createOptionCar}
          border
        />
      </div>
    </>
  );
};

export default CarOptionsCreate;
